import React from 'react';
import { Section } from '../ui/Section';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  return <Section bgColor="beige" data-id="element-182">
      <div className="max-w-4xl mx-auto" data-id="element-183">
        <div className="text-center mt-[0px] mb-[0px]" data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-serif text-[#4A1D6E] mb-8" data-id="element-185">
            +200 mujeres pasaron de esto...
          </h2>

          <div className="flex flex-col md:flex-row gap-4 justify-center mb-12 opacity-70" data-id="element-186">
            <div className="bg-white/50 px-6 py-3 rounded-sm italic text-[#070707]" data-id="element-187">
              "No sé qué me pasa."
            </div>
            <div className="bg-white/50 px-6 py-3 rounded-sm italic text-[#070707]" data-id="element-188">
              "Siempre termino en el mismo lugar."
            </div>
            <div className="bg-white/50 px-6 py-3 rounded-sm italic text-[#070707]" data-id="element-189">
              "Hay algo en mí que me frena."
            </div>
          </div>

          <div className="text-[#4A1D6E] text-3xl md:text-4xl mb-8 font-serif select-none flex items-center justify-center gap-3" data-id="element-190">
            <span className="text-4xl md:text-5xl font-bold" data-id="element-191">→</span>
            <span className="italic" data-id="element-192">A esto...</span>
          </div>

          <div className="flex flex-col md:flex-row gap-4 justify-center mb-16" data-id="element-193">
            <div className="bg-brand-violet text-white px-6 py-3 rounded-sm shadow-md font-medium" data-id="element-194">
              "Ahora entiendo de dónde viene."
            </div>
            <div className="bg-brand-violet text-white px-6 py-3 rounded-sm shadow-md font-medium" data-id="element-195">
              "Puedo ver el patrón."
            </div>
            <div className="bg-brand-violet text-white px-6 py-3 rounded-sm shadow-md font-medium" data-id="element-196">
              "Ya no quiero seguir tratándome así."
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-197">
          {/* Testimonial 1 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-198">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-199" />
            <div className="flex text-brand-champagne mb-4" data-id="element-200">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-201" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-202">
              "Nunca había podido poner en palabras lo que sentía. Este journal
              me guió paso a paso y por primera vez siento que entiendo por qué
              elijo las parejas que elijo. Es un antes y un después."
            </p>
            <div className="flex items-center gap-4" data-id="element-203">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-204">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-205" />
              </div>
              <div data-id="element-206">
                <p className="font-serif font-medium text-brand-dark" data-id="element-207">
                  María L.
                </p>
                <p className="text-xs text-brand-light" data-id="element-208">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-209">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-210" />
            <div className="flex text-brand-champagne mb-4" data-id="element-211">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-212" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-213">
              "Pensé que me iba a costar porque nunca escribo, pero las
              preguntas son tan exactas que las respuestas salen solas. Me ayudó
              a soltar mucha culpa que venía cargando hace años."
            </p>
            <div className="flex items-center gap-4" data-id="element-214">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-215">
                <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-216" />
              </div>
              <div data-id="element-217">
                <p className="font-serif font-medium text-brand-dark" data-id="element-218">
                  Sofía C.
                </p>
                <p className="text-xs text-brand-light" data-id="element-219">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-220">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-221" />
            <div className="flex text-brand-champagne mb-4" data-id="element-222">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-223" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-224">
              "Lo que más me sorprendió fue darme cuenta de que mis miedos no
              eran míos, sino heredados. Ahora puedo elegir conscientemente en
              vez de reaccionar automáticamente."
            </p>
            <div className="flex items-center gap-4" data-id="element-225">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-226">
                <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-227" />
              </div>
              <div data-id="element-228">
                <p className="font-serif font-medium text-brand-dark" data-id="element-229">
                  Valentina R.
                </p>
                <p className="text-xs text-brand-light" data-id="element-230">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-231">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-232" />
            <div className="flex text-brand-champagne mb-4" data-id="element-233">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-234" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-235">
              "Estaba en terapia hace meses sin avanzar. Este journal me ayudó a
              ordenar todo lo que venía sintiendo y llevé mis respuestas a
              sesión. Mi terapeuta quedó impresionada con mi claridad."
            </p>
            <div className="flex items-center gap-4" data-id="element-236">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-237">
                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-238" />
              </div>
              <div data-id="element-239">
                <p className="font-serif font-medium text-brand-dark" data-id="element-240">
                  Luciana M.
                </p>
                <p className="text-xs text-brand-light" data-id="element-241">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 5 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-242">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-243" />
            <div className="flex text-brand-champagne mb-4" data-id="element-244">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-245" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-246">
              "Después de años de autoexigencia y burnout, este journal me
              enseñó a tratarme con compasión. Las preguntas sobre mi niña
              interior me hicieron llorar y sanar al mismo tiempo."
            </p>
            <div className="flex items-center gap-4" data-id="element-247">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-248">
                <img src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-249" />
              </div>
              <div data-id="element-250">
                <p className="font-serif font-medium text-brand-dark" data-id="element-251">
                  Carolina P.
                </p>
                <p className="text-xs text-brand-light" data-id="element-252">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 6 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-253">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-254" />
            <div className="flex text-brand-champagne mb-4" data-id="element-255">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-256" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-257">
              "No esperaba que un journal digital fuera tan potente. El
              asistente IA me acompañó en momentos difíciles cuando no tenía con
              quién hablar. Sentí que alguien me entendía de verdad."
            </p>
            <div className="flex items-center gap-4" data-id="element-258">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-259">
                <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-260" />
              </div>
              <div data-id="element-261">
                <p className="font-serif font-medium text-brand-dark" data-id="element-262">
                  Jimena S.
                </p>
                <p className="text-xs text-brand-light" data-id="element-263">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 7 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-264">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-265" />
            <div className="flex text-brand-champagne mb-4" data-id="element-266">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-267" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-268">
              "Terminé una relación tóxica hace poco y este journal me está
              ayudando a no volver a caer en lo mismo. Entendí que el problema
              no era encontrar a alguien mejor, sino sanar mi relación conmigo."
            </p>
            <div className="flex items-center gap-4" data-id="element-269">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-270">
                <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-271" />
              </div>
              <div data-id="element-272">
                <p className="font-serif font-medium text-brand-dark" data-id="element-273">
                  Florencia G.
                </p>
                <p className="text-xs text-brand-light" data-id="element-274">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 8 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-275">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-276" />
            <div className="flex text-brand-champagne mb-4" data-id="element-277">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-278" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-279">
              "Las afirmaciones diarias son oro puro. Cada mañana leo una y me
              acompaña todo el día. Siento que estoy reprogramando mi mente de a
              poco, con paciencia y amor."
            </p>
            <div className="flex items-center gap-4" data-id="element-280">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-281">
                <img src="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-282" />
              </div>
              <div data-id="element-283">
                <p className="font-serif font-medium text-brand-dark" data-id="element-284">
                  Agustina F.
                </p>
                <p className="text-xs text-brand-light" data-id="element-285">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 9 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-286">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-287" />
            <div className="flex text-brand-champagne mb-4" data-id="element-288">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-289" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-290">
              "Compré el journal pensando que era 'otro más', pero la estructura
              progresiva es brillante. Cada pregunta te prepara para la
              siguiente. No es solo escribir, es un proceso real de
              transformación."
            </p>
            <div className="flex items-center gap-4" data-id="element-291">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-292">
                <img src="https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-293" />
              </div>
              <div data-id="element-294">
                <p className="font-serif font-medium text-brand-dark" data-id="element-295">
                  Camila D.
                </p>
                <p className="text-xs text-brand-light" data-id="element-296">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial 10 */}
          <div className="bg-white p-8 rounded-sm shadow-card relative" data-id="element-297">
            <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-cream" data-id="element-298" />
            <div className="flex text-brand-champagne mb-4" data-id="element-299">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-300" />)}
            </div>
            <p className="text-brand-dark mb-6 leading-relaxed relative z-10" data-id="element-301">
              "El Kit de Emergencia Emocional me salvó en una crisis de ansiedad
              a las 2am. Tener esas técnicas y saber que puedo llamar a la línea
              135 me dio una seguridad que nunca había sentido."
            </p>
            <div className="flex items-center gap-4" data-id="element-302">
              <div className="w-12 h-12 bg-brand-beige rounded-full overflow-hidden" data-id="element-303">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=200&auto=format&fit=crop" alt="User" className="w-full h-full object-cover" data-id="element-304" />
              </div>
              <div data-id="element-305">
                <p className="font-serif font-medium text-brand-dark" data-id="element-306">
                  Martina B.
                </p>
                <p className="text-xs text-brand-light" data-id="element-307">
                  Compradora verificada
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}